import * as React from "react";
import type { SVGProps } from "react";
const SvgAegeanAirlines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 51 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#88A8D8"
      d="M32.822 25H42a25.87 25.87 0 0 1-11.24-11.354C26.84 5.625 19.105.938 9 0l.206.73c6.91 2.812 11.756 7.29 14.54 13.645 2.063 4.27 5.157 8.02 9.076 10.625"
    />
    <path
      fill="#1C4093"
      d="M32.822 25H42a25.87 25.87 0 0 0-11.24 11.354C26.84 44.48 19.105 49.063 9 50l.206-.73c6.91-2.812 11.756-7.29 14.54-13.645 2.063-4.27 5.157-8.02 9.076-10.625"
    />
    <path
      fill="#88A8D8"
      d="M9 8.125c1.65 6.25 3.919 11.354 5.878 13.854 1.031 1.354 2.372 2.396 3.816 3.021h7.219a15.36 15.36 0 0 1-7.632-7.708C16.528 13.125 13.125 9.896 9 8.125"
    />
    <path
      fill="#1C4093"
      d="M9 41.875c1.65-6.25 3.919-11.354 5.878-13.854 1.031-1.354 2.372-2.396 3.816-3.021h7.219a15.36 15.36 0 0 0-7.632 7.708c-1.753 4.167-5.156 7.5-9.281 9.167"
    />
  </svg>
);
export default SvgAegeanAirlines;
